module.exports = __webpack_public_path__ + "img/access-ac.be9f3106.svg";